import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';

const dietSplashHtml = locHtml((t) => `
<div class="new-quote-container centered"> 
  <div class="splash-icon">🌱</div>
  <div class="splash-header">
    <h1>${t("splash.diet.title")}</h1>
    <div class="quote">
      ${t("splash.diet.text")}
    </div>
  </div>
</div>`);

const dietSplashElement = {
  visibleIf: `{diet} > 3`,
  name: 'diet-splash',
  type: 'html',
  html: dietSplashHtml,
};

const DietSplashHeader = makeSplashHeader("splash.headers.diet");


export {
  dietSplashElement,
  DietSplashHeader,
}